import Home from "./components/Home.vue";
import HomeEmpresas from "./components/HomeEmpresa";
import HomeRegistro from "./components/HomeRegistro";
import Profile from "./components/sections/Profile.vue";
import Avatar from "./components/sections/Avatar.vue";
import Login from "./components/startPage/Login.vue";
import ForgotPassword from "./components/startPage/ForgotPassword.vue";
import RecoverPassword from "./components/startPage/RecoverPassword.vue";
import NuevaPassword from "./components/startPage/NuevaPassword.vue";
import SecretCode from "./components/startPage/SecretCode.vue";
import Register from "./components/startPage/Register.vue";
import Registrate from "./components/startPage/Registrate.vue";
import AdminCategories from "./components/admin/AdminCategories.vue";
import AdminPuntaje from "./components/admin/AdminPuntaje.vue";
import AdminNivel from "./components/admin/AdminNivel.vue";
import NewCategory from "./components/categories/NewCategory.vue";
import AdminCursos from "./components/admin/AdminCursos.vue";
import NewCourse from "./components/admin/NewCourse.vue";
import Activity from "./components/sections/Activity.vue";
import Content from "./components/sections/Content.vue";
import ActivitiesCategory from "./components/sections/ActivitiesCategory.vue";
import Challenge from "./components/sections/Challenge.vue";
import NewArkidian from "./components/sections/NewArkidian.vue";
import ArkidiansAdmin from "./components/sections/ArkidiansAdmin.vue";
import MyProfile from "./components/sections/MyProfile.vue";
import AdminChallenge from "./components/admin/AdminChallenge.vue";
import AdminMessages from "./components/admin/AdminMessages.vue";
import Notificaciones from "./components/sections/Notificaciones.vue";
import Thanks from "./components/sections/Thanks.vue";
import Test from "./components/Test.vue";

export const routes = [
  { path: "/", component: Home },
  { path: "/Empresas", component: HomeEmpresas },
  { path: "/AcaComienzaLaDiversion", component: HomeRegistro },
  { path: "/Perfil/:id", name: "Perfil", component: Profile, props: true },
  { path: "/MiPerfil", name: "MiPerfil", component: MyProfile },
  { path: "/Login/:usuario", name: "Login", component: Login, props: true },
  { path: "/Password", name: "Password", component: ForgotPassword },
  { path: "/Register", name: "Register", component: Register },
  { path: "/Registrate", name: "Registrate", component: Registrate },
  { path: "/Categorias", name: "Categorias", component: AdminCategories },
  { path: "/Puntajes", name: "Puntajes", component: AdminPuntaje },
  { path: "/Niveles", name: "Niveles", component: AdminNivel },
  {
    path: "/Admin/Categorias/Nueva",
    name: "CategoriaNueva",
    component: NewCategory
  },
  { path: "/Cursos", name: "Cursos", component: AdminCursos },
  { path: "/Admin/Cursos/:accion/:id", component: NewCourse, props: true },
  { path: "/Activity/:id", component: Activity, props: true },
  { path: "/Contenido", component: Content },
  { path: "/Categoria/:id", component: ActivitiesCategory, props: true },
  { path: "/Desafio/:idDesafio/:idUsuario", component: Challenge, props: true },
  { path: "/NuevoArkidian", component: NewArkidian },
  { path: "/Arkidians", component: ArkidiansAdmin },
  { path: "/AprobarChallenge", component: AdminChallenge },
  { path: "/AprobarMensajes", component: AdminMessages },
  { path: "/Notificaciones", component: Notificaciones },
  { path: "/Test/:id", component: Test, props: true },
  { path: "/Recuperar", component: RecoverPassword },
  { path: "/CodigoSecreto/:tipo/:mail", component: SecretCode, props: true },
  { path: "/NuevaPassword/:codigo", component: NuevaPassword, props: true },
  { path: "/Gracias", component: Thanks },
  { path: "/Avatar", component: Avatar }
];



// WEBPACK FOOTER //
// ./src/routes.js